/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { FieldLabComponent } from "@src/app/pages/field-lab/field-lab.component";
import { NavRoute } from "@src/app/shared/NavRoute";

/**
 * Deliberately absent from every menu - the lab is reached from the Field Lab button on My Profile.
 *
 * The one view turns on an empty filter for every field the filter component will accept, so the
 * lab lands showing each filter control at once. A null value activates the filter without adding
 * a query parameter, so nothing is actually filtered out - see FormPageComponent.setQueryFilter.
 * Fields the filter component does not handle (boolean, phone, url, longText, richText,
 * link) are absent on purpose, and would only log a warning if listed.
 */
export const FieldLabNavRoute = new NavRoute('fieldlab', () => FieldLabComponent, 'science')
    .setViews(() => [
        {
            id: 'allFilters',
            name: 'All Filters',
            helpText: 'Every filterable field, with an empty filter, to eyeball the filter controls',
            filterFields: {
                title: null,
                startDate: null,
                lastSeenAt: null,
                email: null,
                quantity: null,
                amount: null,
                rate: null,
                timeSpent: null,
                statusId: null,
                categoryId: null,
                priorityId: null,
                unitId: null,
                personId: null,
                ownerId: null,
                reviewDate: null,
                approvedAt: null,
                balance: null,
            },
        },
    ]);
